import React, { useState } from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import ValidationSchema from '../../helpers/ValidationSchema';
import Spinner from '../Spinner';
import closeEyeIcon from '../../assets/icons/eyeClose.svg';
import openEyeIcon from '../../assets/icons/eyeOpen.svg';

import { resetPasswordApi } from '../../store/actions/user';
import toggleRegisterForm from '../../store/actions/registerFormToggle';

function ResetPassword() {
  const { resetPassword } = ValidationSchema();
  const [loading, setLoading] = useState(false);
  const [openPassword, setOpenPassword] = useState(true);
  const { translations } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSendRecoverCode = async (values) => {
    setLoading(true);
    const { payload } = await dispatch(resetPasswordApi({
      password: values.new_password,
      password_confirmation: values.new_password_confirmation,
      token: window.location.search.split('=')[1],
      lang,
    }));
    if (!payload.error) {
      toast(payload.data, { type: 'success', autoClose: 3000 });
      navigate(`/${lang}`);
      dispatch(toggleRegisterForm({ visible: true, type: 'login' }));
    } else {
      toast(payload.error, { type: 'error', autoClose: 3000 });
    }
    setLoading(false);
  };
  return (
    <Formik
      initialValues={{
        new_password: '',
        new_password_confirmation: '',
      }}
      onSubmit={(values, actions) => {
        handleSendRecoverCode(values);
        actions.setSubmitting(false);
      }}
      validationSchema={resetPassword}
    >
      <Form className="register-form">
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="new_password">{translations.new_password_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              type={openPassword ? 'password' : 'text'}
              as="input"
              name="new_password"
              id="new_password"
              placeholder={translations.new_password_placeholder[lang]}
            />
            <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
              <img
                src={openPassword ? closeEyeIcon : openEyeIcon}
                alt="eye"
              />
            </button>
          </div>
          <ErrorMessage
            name="new_password"
            component="p"
            className="authError"
          />
        </div>
        <div className="register-form-group">
          <label className="inputs-label" htmlFor="new_password_confirmation">{translations.confirm_password_label[lang]}</label>
          <div className="register-form-group_input input-block">
            <Field
              type={openPassword ? 'password' : 'text'}
              as="input"
              name="new_password_confirmation"
              id="new_password_confirmation"
              placeholder={translations.confirm_password_placeholder[lang]}
            />
            <button className="password-eye" type="button" onClick={() => setOpenPassword(!openPassword)}>
              <img
                src={openPassword ? closeEyeIcon : openEyeIcon}
                alt="eye"
              />
            </button>
          </div>
          <ErrorMessage
            name="new_password_confirmation"
            component="p"
            className="authError"
          />
        </div>
        <button type="submit" className="register-form-button">
          {
            loading ? <Spinner isBtn size={30} />
              : <p>{translations.confirm[lang]}</p>
          }
        </button>
      </Form>
    </Formik>
  );
}

export default ResetPassword;
